import {
    ChangeDetectionStrategy,
    Component, ContentChild,
    Input,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { KalInputComponent } from '@kalidea/kaligraphi';
import { FormValidator } from 'src/app/validators/form-validator';

@Component({
    selector: 'app-input-counter',
    templateUrl: './input-counter.component.html',
    styleUrls: ['./input-counter.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InputCounterComponent {

    @Input()
    minValue = 0;

    @Input()
    maxValue = null;

    control = new UntypedFormControl(1, [FormValidator.number, Validators.min(1)]);

    @ContentChild(KalInputComponent, {static: true}) kalInputComponent: KalInputComponent;

    constructor() {
    }

    get disabled(): boolean {
        return this.kalInputComponent.disabled;
    }

    get value(): number {
        const value = +this.kalInputComponent.value;
        return !isNaN(value) ? value : 0;
    }

    up() {
        if (this.disabled) {
            return;
        }

        this.kalInputComponent.control.patchValue(Math.min(this.maxValue || this.value + 1, this.value + 1));
    }

    down() {
        if (this.disabled) {
            return;
        }

        this.kalInputComponent.control.patchValue(Math.max(this.minValue, this.value - 1));
    }
}
